if (!customElements.get("sticky-add-cart")) {
  customElements.define(
    "sticky-add-cart",
    class StickyAddToCart extends HTMLElement {
      constructor() {
        super();
        this.onVariantChangeUnsubscriber = undefined;
        this._onScroll = this.displayStickyAddToCart.bind(this);
        this._onResize = this.displayStickyAddToCart.bind(this);
      }

      connectedCallback() {
        this.container = this.querySelector("#stickyAddtocartContainer");

        this.onVariantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, () => {
          this.renderStickyAddToCart();
        });

        window.addEventListener("scroll", this._onScroll, { passive: true });
        window.addEventListener("resize", this._onResize);

        this.displayStickyAddToCart();
      }

      disconnectedCallback() {
        window.removeEventListener("scroll", this._onScroll);
        window.removeEventListener("resize", this._onResize);
        if (this.onVariantChangeUnsubscriber) this.onVariantChangeUnsubscriber();
      }

      renderStickyAddToCart() {
        const sectionEl = this.closest(".shopify-section");
        if (!sectionEl) return;

        const sectionId = sectionEl.id.replace("shopify-section-", "");
        let urlToFetch = window.location.href;

        urlToFetch += urlToFetch.includes("?")
          ? `&sections=${sectionId}`
          : `?sections=${sectionId}`;

        fetch(urlToFetch)
          .then((res) => res.json())
          .then((data) => {
            const html = new DOMParser().parseFromString(data[sectionId], "text/html");
            const newContainer = html.querySelector("#stickyAddtocartContainer");
            if (!newContainer || !this.container) return;

            // ✅ On remplace uniquement le contenu (sinon classes/variables cassent)
            this.container.innerHTML = newContainer.innerHTML;
          })
          .then(() => {
            const qb = document.querySelector("quantity-breaks");
            if (qb) qb.updateMainPrice();
          });
      }

      displayStickyAddToCart() {
        if (!this.container) return;

        const isDesktop = window.matchMedia("(min-width: 750px)").matches;

        // ✅ Desktop : si pas activé via classe -> on force hidden
        if (isDesktop && !this.container.classList.contains("is-desktop-enabled")) {
          this.container.classList.remove("showStickyAddtocart");
          this.container.classList.add("hideStickyAddtocart");
          return;
        }

        const mainAtcBtn = this.getMainATCButton();
        const footer = document.querySelector("footer");
        const footerVisible = footer ? this.isElementInViewport(footer) : false;

        // Footer visible => toujours cacher
        if (footerVisible) {
          this.container.classList.remove("showStickyAddtocart");
          this.container.classList.add("hideStickyAddtocart");
          return;
        }

        // Si pas de bouton ATC principal => cacher
        if (!mainAtcBtn) {
          this.container.classList.remove("showStickyAddtocart");
          this.container.classList.add("hideStickyAddtocart");
          return;
        }

        // ✅ DESKTOP : comportement "comme avant"
        if (isDesktop) {
          const mainAtcVisible = this.isElementInViewport(mainAtcBtn);

          if (mainAtcVisible) {
            this.container.classList.remove("showStickyAddtocart");
            this.container.classList.add("hideStickyAddtocart");
          } else {
            this.container.classList.remove("hideStickyAddtocart");
            this.container.classList.add("showStickyAddtocart");
          }
          return;
        }

        // ✅ MOBILE : s’affiche UNIQUEMENT après avoir dépassé le bouton ATC
        const rect = mainAtcBtn.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;

        const atcVisible = rect.top < vh && rect.bottom > 0;
        const atcPassed = rect.bottom <= 0; // dépassé = le bas du bouton est au-dessus du viewport

        if (atcVisible || !atcPassed) {
          this.container.classList.remove("showStickyAddtocart");
          this.container.classList.add("hideStickyAddtocart");
        } else {
          this.container.classList.remove("hideStickyAddtocart");
          this.container.classList.add("showStickyAddtocart");
        }
      }

      // ✅ On prend le bouton ATC principal (pas celui du sticky)
      getMainATCButton() {
        const scope = this.closest(".shopify-section") || document;
        const buttons = Array.from(scope.querySelectorAll(".product-form__submit"));

        for (const btn of buttons) {
          if (!btn.closest("sticky-add-cart")) return btn;
        }
        return buttons[0] || null;
      }

      isElementInViewport(el) {
        if (!el) return false;

        let top = el.offsetTop;
        const height = el.offsetHeight;

        while (el.offsetParent) {
          el = el.offsetParent;
          top += el.offsetTop;
        }

        return top < window.pageYOffset + window.innerHeight && top + height > window.pageYOffset;
      }
    }
  );
}
